import axios from 'axios';

const instance = axios.create({
  baseURL: "https://ws.crfcoralregistry.com/",
  withCredentials: true, // Include credentials in all requests
});

export default instance;
